/* Card page: turns variants named "<condition>" / "<condition> - <finish>" into two pickers
   (Finish, Condition) with price and stock for each choice. Store-neutral: the conditions,
   separator and normal-finish name come from Theme settings > Card shop. */
(function () {
  function money(cents, format) {
    const f = format || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const fix = (d, th, dec) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dec);
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? fix(0, ',', '.')
      : k === 'amount_with_comma_separator' ? fix(2, '.', ',')
      : k === 'amount_no_decimals_with_comma_separator' ? fix(0, '.', ',')
      : k === 'amount_with_apostrophe_separator' ? fix(2, "'", '.')
      : fix(2, ',', '.'));
  }
  const abbr = (s) => {
    const w = String(s).trim().split(/\s+/);
    if (w.length > 1) return w.map((x) => x[0]).join('').toUpperCase();
    const one = w[0] || '';
    return one.length <= 3 ? one.toUpperCase() : (one[0] + one.slice(1).replace(/[aeiou]/gi, '').slice(0, 2)).toUpperCase(); // Damaged -> DMG
  };

  function init(root) {
    const cfgEl = root.querySelector('[data-mbg-config]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    const V = cfg.variants || [];
    if (!V.length) return;
    const norm = (s) => String(s).trim().toLowerCase();
    const condOrder = (cfg.conditions || []).map((c) => String(c).trim()).filter(Boolean);
    const conds = [];
    condOrder.forEach((c) => { if (V.some((v) => norm(v.c) === norm(c))) conds.push(V.find((v) => norm(v.c) === norm(c)).c); });
    V.forEach((v) => { if (!conds.some((c) => norm(c) === norm(v.c))) conds.push(v.c); });
    const finishes = [];
    if (V.some((v) => v.f === cfg.normal)) finishes.push(cfg.normal);
    V.forEach((v) => { if (!finishes.includes(v.f)) finishes.push(v.f); });

    const $ = (s) => root.querySelector(s);
    const elF = $('[data-mbg-finishes]'), elC = $('[data-mbg-conds]'), elFwrap = $('[data-mbg-finish-wrap]');
    const elPrice = $('[data-mbg-price]'), elWas = $('[data-mbg-was]'), elStock = $('[data-mbg-stock]'), elQty = $('[data-mbg-qty]');
    const form = root.querySelector('product-form form'), idInput = form && form.querySelector('[name=id]');
    const btn = form && form.querySelector('[type=submit]'), btnText = btn && btn.querySelector('span');

    const find = (f, c) => V.find((v) => v.f === f && norm(v.c) === norm(c));
    const stockOf = (v) => (!v ? 0 : v.q == null ? (v.a ? null : 0) : v.q);
    const qtyText = (n) => (cfg.showStock && n != null ? ` <span class="mbg-opt__n">${n}</span>` : '');
    let cur = V.find((v) => String(v.id) === String(cfg.selected)) || V.find((v) => v.a) || V[0];

    function pick(f, c) {
      let v = find(f, c);
      if (!v) {
        const inF = conds.map((x) => find(f, x)).filter(Boolean);
        v = inF.find((x) => x.a) || inF[0];
      }
      if (v) { cur = v; draw(); }
    }

    function draw() {
      // finishes
      if (finishes.length < 2) elFwrap.hidden = true;
      elF.innerHTML = finishes.map((f) => {
        const vs = V.filter((v) => v.f === f);
        const any = vs.some((v) => v.a);
        const n = vs.every((v) => v.q != null) ? vs.reduce((a, v) => a + v.q, 0) : null;
        return `<button type="button" role="radio" aria-checked="${f === cur.f}" class="mbg-opt${f === cur.f ? ' is-on' : ''}${any ? '' : ' is-out'}" data-f="${encodeURIComponent(f)}">${escapeHtml(f)}${qtyText(n)}</button>`;
      }).join('');
      // conditions for the chosen finish
      elC.innerHTML = conds.map((c) => {
        const v = find(cur.f, c);
        if (!v) return '';
        const on = v.id === cur.id;
        return `<button type="button" role="radio" aria-checked="${on}" title="${escapeHtml(c)} · ${money(v.p, cfg.money)}" class="mbg-opt${on ? ' is-on' : ''}${v.a ? '' : ' is-out'}" data-c="${encodeURIComponent(c)}">${escapeHtml(abbr(c))}${qtyText(stockOf(v))}</button>`;
      }).join('');
      elF.querySelectorAll('[data-f]').forEach((b) => b.addEventListener('click', () => pick(decodeURIComponent(b.dataset.f), cur.c)));
      elC.querySelectorAll('[data-c]').forEach((b) => b.addEventListener('click', () => pick(cur.f, decodeURIComponent(b.dataset.c))));

      elPrice.textContent = money(cur.p, cfg.money);
      if (cur.cp > cur.p) { elWas.hidden = false; elWas.textContent = money(cur.cp, cfg.money); } else elWas.hidden = true;
      const n = stockOf(cur);
      elStock.textContent = `${cur.c}${finishes.length > 1 ? ' · ' + cur.f : ''} — ` + (!cur.a ? 'out of stock' : n == null ? 'in stock' : cfg.showStock ? `${n} in stock` : 'in stock');
      elStock.classList.toggle('is-out', !cur.a);
      if (idInput) { idInput.value = cur.id; idInput.disabled = false; }
      if (elQty) { if (n != null && n > 0) elQty.max = n; else elQty.removeAttribute('max'); if (n && Number(elQty.value) > n) elQty.value = n; }
      if (btn) {
        if (cur.a) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); if (btnText) btnText.textContent = cfg.addToCart; }
        else { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = cfg.soldOut; }
      }
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', cur.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* ignore */ }
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m])); }
    draw();
  }

  const run = () => document.querySelectorAll('.mbg-card').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
